var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsLeftright = function SvgArrowsLeftright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.675 11.4a1.5 1.5 0 1 0 2.4-1.8l-1.2-1.601H11.5a1.5 1.5 0 0 0 0-3H4.876l1.2-1.6a1.5 1.5 0 1 0-2.4-1.8L0 6.5l3.675 4.9ZM16.324 8.6a1.5 1.5 0 1 0-2.4 1.8l1.2 1.601H8.499a1.5 1.5 0 0 0 0 3h6.624l-1.2 1.6a1.5 1.5 0 1 0 2.4 1.8l3.675-4.9-3.675-4.9Z"
  })));
};
export default SvgArrowsLeftright;